function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { onBeforeMount, reactive, ref, toRefs, watch } from "vue";
//@ts-ignore
import { updateNote as updateNoteAPI } from "@services/publicUserAPI";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import { getRealEstateNotes } from "@services/realEstateAPI";
//@ts-ignore
import { showAddFavoritesIcon, showRemoveFavoritesIcons } from "@utils/favoriteUtils";
//@ts-ignore
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
//@ts-ignore
import { useLoggedUserStore } from "@store/LoggedUserStore";
//@ts-ignore
import { useModalStore } from "@store/ModalStore";
//@ts-ignore
import { decodeCookie, encodeCookie } from "@utils/CookieUtils";
//@ts-ignore
import { emptyElem } from "@utils/DOMUtils";
export function useFavourite() {
  var _this = this;
  var state = reactive({
    tempFavoritesIdList: null,
    notes: "",
    disableNotes: true,
    focusNotes: false,
    notesInitialized: false,
    clearTextarea: false,
    curRealEstateId: null
  });
  var loggedUserStore = useLoggedUserStore();
  var publicUserMenuStore = usePublicUserMenuStore();
  var modalStore = useModalStore();
  var textareas = ref({});
  var favoriteIdToDelete = ref(null);
  var handleAddFavorite = function handleAddFavorite(id) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var tempFavorites, favCookie;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (id) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            if (!loggedUserStore.isUserLogged) {
              tempFavorites = [];
              tempFavorites.push(id);
              sessionStorage.setItem("tempFavorites", JSON.stringify(tempFavorites));
            }
            checkIfUserIsLogged();
            _context.next = 7;
            return publicUserMenuStore.addFavorite(id);
          case 7:
            showRemoveFavoritesIcons(id);
            favCookie = decodeCookie("activeFavCookie"); // EDIT mailAlertOnFavouriteModal, now it has been shown every 24h even if user already have favourites
            if (favCookie === null) {
              encodeCookie("activeFavCookie", true, 1);
              modalStore.setShowModal(Modals.mailAlertOnFavouriteModal);
            }
            _context.next = 14;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12]]);
    }));
  };
  var handleRemoveFavorite = function handleRemoveFavorite(id) {
    var withModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!withModal) {
      publicUserMenuStore.removeFavorite(id).then(function () {
        showAddFavoritesIcon(id);
      });
      return;
    }
    modalStore.showModal = Modals.confirmDeleteFavoriteModal;
    favoriteIdToDelete.value = id;
  };
  var removeSingleFavorite = function removeSingleFavorite() {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _a;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (favoriteIdToDelete.value) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return publicUserMenuStore.removeFavorite(favoriteIdToDelete.value);
          case 5:
            (_a = document.querySelector("li[data-id='li-article-".concat(favoriteIdToDelete.value, "']"))) === null || _a === void 0 ? void 0 : _a.remove();
            modalStore.showModal = Modals.noModal;
            _context2.next = 12;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            console.error(_context2.t0);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 9]]);
    }));
  };
  var handleRemoveAllFavorites = function handleRemoveAllFavorites() {
    var withModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!withModal) return;
    modalStore.showModal = Modals.confirmDeleteAllFavoritesModal;
  };
  var removeAllFavorites = function removeAllFavorites() {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return publicUserMenuStore.removeFavorites();
          case 3:
            emptyElem("#list-favourites");
            modalStore.showModal = Modals.noModal;
            _context3.next = 10;
            break;
          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 7]]);
    }));
  };
  var handleEditNote = function handleEditNote(id) {
    var _a, _b;
    try {
      checkIfUserIsLogged();
      (_a = document.getElementById("fav-note-".concat(id))) === null || _a === void 0 ? void 0 : _a.classList.add("fav-note-show", "fav-note-editing");
      (_b = document.getElementById("fav-bt-".concat(id))) === null || _b === void 0 ? void 0 : _b.focus();
    } catch (error) {
      //In this case the user is not logged in!
    }
  };
  var updateNote = function updateNote(id) {
    var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var single = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var hideTextArea = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var notesValue, textAreaElem;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            if (!(publicUserMenuStore.getFavoriteById(id) === -1)) {
              _context4.next = 4;
              break;
            }
            _context4.next = 4;
            return handleAddFavorite(id);
          case 4:
            state.clearTextarea = false;
            if (remove) {
              state.notes = "";
              if (single) state.clearTextarea = true;else {
                textareas.value["textarea-".concat(id)].clearTextareaElem();
              }
            }
            notesValue = single ? state.notes : document.getElementById("fav-bt-".concat(id)).value;
            _context4.next = 9;
            return updateNoteAPI(id, notesValue);
          case 9:
            textAreaElem = document.getElementById("fav-note-".concat(id));
            if (state.notes) textAreaElem === null || textAreaElem === void 0 ? void 0 : textAreaElem.classList.remove("fav-note-editing");else if (!state.notes && hideTextArea) textAreaElem === null || textAreaElem === void 0 ? void 0 : textAreaElem.classList.remove("fav-note-show", "fav-note-editing");
            if (single) state.disableNotes = true;else {
              textareas.value["textarea-".concat(id)].disableTextarea();
            }
            _context4.next = 17;
            break;
          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4["catch"](0);
            console.error(_context4.t0);
            //favorite could not been added
            //update error
          case 17:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 14]]);
    }));
  };
  var editAndShowButtons = function editAndShowButtons(id, editText) {
    var single = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _a;
    if (editText !== undefined && single) {
      //Updating this variable iff there is just a single textarea
      state.notes = editText;
    }
    try {
      checkIfUserIsLogged();
      (_a = document.getElementById("fav-note-".concat(id))) === null || _a === void 0 ? void 0 : _a.classList.add("fav-note-show", "fav-note-editing");
      if (single) {
        state.disableNotes = false;
        state.focusNotes = true;
      } else {
        textareas.value["textarea-".concat(id)].disableAndFocusTextarea();
      }
    } catch (error) {
      //In this case the user is not logged in!
    }
  };
  var checkIfUserIsLogged = function checkIfUserIsLogged() {
    if (!loggedUserStore.isUserLogged) {
      modalStore.setShowModal(Modals.loginModal);
      throw "The user must to login if he wants to make this action";
    }
  };
  var openNoteModal = function openNoteModal() {
    try {
      checkIfUserIsLogged();
      modalStore.setShowModal(Modals.noteModal);
    } catch (error) {
      //In this case the user is not logged in!
    }
  };
  var initNotes = function initNotes(realEstateMiniItemId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            state.curRealEstateId = realEstateMiniItemId;
            _context5.next = 3;
            return getRealEstateNotes(realEstateMiniItemId);
          case 3:
            state.notes = _context5.sent;
            state.notesInitialized = !!(state.notes && loggedUserStore.isUserLogged);
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  };
  // This function should be called when the user logs in
  var saveTempFavorites = function saveTempFavorites() {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var tempFavorites, _iterator, _step, id;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            tempFavorites = JSON.parse(sessionStorage.getItem("tempFavorites") || "[]");
            _iterator = _createForOfIteratorHelper(tempFavorites);
            _context6.prev = 2;
            _iterator.s();
          case 4:
            if ((_step = _iterator.n()).done) {
              _context6.next = 16;
              break;
            }
            id = _step.value;
            _context6.prev = 6;
            _context6.next = 9;
            return publicUserMenuStore.addFavorite(id);
          case 9:
            showRemoveFavoritesIcons(id);
            _context6.next = 14;
            break;
          case 12:
            _context6.prev = 12;
            _context6.t0 = _context6["catch"](6);
          case 14:
            _context6.next = 4;
            break;
          case 16:
            _context6.next = 21;
            break;
          case 18:
            _context6.prev = 18;
            _context6.t1 = _context6["catch"](2);
            _iterator.e(_context6.t1);
          case 21:
            _context6.prev = 21;
            _iterator.f();
            return _context6.finish(21);
          case 24:
            // Clear the temp favorites from session storage
            sessionStorage.removeItem("tempFavorites");
          case 25:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 18, 21, 24], [6, 12]]);
    }));
  };
  onBeforeMount(function () {
    watch(function () {
      return loggedUserStore.isUserLogged;
    }, function (cur) {
      if (cur) {
        saveTempFavorites();
        state.notesInitialized = false;
        if (!state.curRealEstateId) return;
        initNotes(state.curRealEstateId);
      }
    });
    watch(function () {
      return publicUserMenuStore.favoriteIdList;
    }, function (favoriteIdList) {
      var _a;
      if (favoriteIdList.length >= 1 && loggedUserStore.isUserLogged && !state.tempFavoritesIdList) {
        state.tempFavoritesIdList = favoriteIdList;
        favoriteIdList.forEach(function (id) {
          showRemoveFavoritesIcons(id);
        });
      } else if (favoriteIdList.length >= 0 && loggedUserStore.isUserLogged && state.tempFavoritesIdList) {
        //In this scenario we have added or removed a  favorite, let's sync it!
        state.tempFavoritesIdList = favoriteIdList;
      } else if (favoriteIdList.length === 0 && !loggedUserStore.isUserLogged) {
        (_a = state.tempFavoritesIdList) === null || _a === void 0 ? void 0 : _a.forEach(function (id) {
          showAddFavoritesIcon(id);
        });
        state.tempFavoritesIdList = null;
      }
    });
    document.addEventListener("init-favorite-event", function (e) {
      var realEstateIdList = e.detail.realEstateIdList;
      realEstateIdList.forEach(function (id) {
        if (!loggedUserStore.isUserLogged) {
          showAddFavoritesIcon(id);
          return;
        }
        //In this scenario the favorite is already in the favoriteIdList
        if (publicUserMenuStore.getFavoriteById(id) >= 0) showRemoveFavoritesIcons(id);else showAddFavoritesIcon(id);
      });
    });
    document.addEventListener("change-favorite-event", function (e) {
      var _e$detail = e.detail,
        realEstateId = _e$detail.realEstateId,
        action = _e$detail.action;
      if (action === "save") {
        handleAddFavorite(realEstateId);
      } else if (action === "delete") {
        handleRemoveFavorite(realEstateId);
      }
    });
  });
  return Object.assign(Object.assign({}, toRefs(state)), {
    textareas: textareas,
    handleAddFavorite: handleAddFavorite,
    handleRemoveFavorite: handleRemoveFavorite,
    handleRemoveAllFavorites: handleRemoveAllFavorites,
    handleEditNote: handleEditNote,
    updateNote: updateNote,
    editAndShowButtons: editAndShowButtons,
    openNoteModal: openNoteModal,
    initNotes: initNotes,
    removeSingleFavorite: removeSingleFavorite,
    removeAllFavorites: removeAllFavorites
  });
}